import { render, staticRenderFns } from "./PageFundraisingGoalDetails.vue?vue&type=template&id=31283720&"
import script from "./PageFundraisingGoalDetails.vue?vue&type=script&lang=ts&"
export * from "./PageFundraisingGoalDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports